import { z } from 'zod/v3';
import {
  transformNull,
  transformToValidPeriod,
  zIsoDate,
} from '../../common/utils';

export const ValidationRuleBaseDataSchema = z.object({
  id: transformNull(z.number().readonly(), -1),
  dataObjectDescriptionVersionId: transformNull(z.number(), -1),
  code: transformNull(z.string(), ''),
  groupCode: z.string().nullable(),
  condition: z.string().nullable(),
  expressionLeft: transformNull(z.string(), ''),
  expressionRight: transformNull(z.string(), ''),
  expressionOperatorId: transformNull(z.number(), -1),
  tolerance: transformNull(z.number(), 0),
  validFrom: zIsoDate().nullable(),
  validTo: zIsoDate().nullable(),
  errorLevelId: transformNull(z.number(), -1),
  errorDescription: z.string().nullable(),
  ignoreError: z.boolean().nullable(),
  ignoreReason: z.string().nullable(),
  statusId: transformNull(z.number(), -1),
});

const transform = <T extends typeof ValidationRuleBaseDataSchema.shape>(
  schemaVariant: z.ZodObject<T>,
) =>
  transformToValidPeriod(schemaVariant) // Workaround for known issue: https://github.com/colinhacks/zod/issues/2732
    .transform(
      (data) =>
        data as Omit<typeof data, 'id' | 'validFrom' | 'validTo'> & {
          readonly id: number;
        },
    );

export const ValidationRuleFormDataSchema = transform(
  ValidationRuleBaseDataSchema,
);
